import styled from 'styled-components'

const MarkerLabel = styled.div`
  background-color: ${props => props.bgColor};
  opacity: ${props => props.opacity};
  border-radius: 7px;
  font-size: 12px;
  padding: 6px 3px;
  text-align: center;
  color: white;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`

export default MarkerLabel



// WEBPACK FOOTER //
// ./src/containers/mapView/components/MarkerLabel.js